import { useAuth } from "../../../../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { getRCSPartners } from "../api/RCSReportByPartners";

export const useGetPartners = () => {
  const auth = useAuth();
  const user = auth.getSessionData();
  return useQuery({
    queryKey: ["getPartners"],
    queryFn: async () => await getRCSPartners({ token: user.token }),
    refetchOnWindowFocus: false,
    initialData: [],
  });
};
